<template>
  <div>
    <div class="row-tb-head" style="margin-top: 10px;">
      <span>费用信息</span>
      <div style="float: right;" v-if="!IsDetail">
        <!-- <el-button type="primary" icon="el-icon-plus" @click="addRow" size="mini">添加</el-button> -->
      </div>
    </div>
    <el-table border class="tb-c-head" :data="Data" @row-click="rowClick" show-summary  :summary-method="getSummaries">
      <el-table-column type="index" label="序号" width="50" align="center" />
      <el-table-column prop="CostName" label="费用名称" min-width="110">
        <template slot-scope="{row}">
          <span v-if="IsDetail">{{row.CostName}}</span>
          <cost-select
            v-else
            v-model="row.CostName"
            :source="DCost"
            @select="onSelect($event,row)"
            :pageSize="pageParams.pageSize"
                :pageIndex="pageParams.pageIndex"
                :listTotal='listTotal'
                @currentPage="currentPage($event, row)"
                @click.native="resetFun(row)"
                @inputText="inputText($event, row)"
                :pageType='true'
          />
        </template>
      </el-table-column>
      <el-table-column prop="CostCode" label="费用编号" min-width="110" />
      <el-table-column prop="Amount" label="金额">
        <template slot-scope="{row}">
          <span v-if="IsDetail">{{$commonJs.toThousands(row.Amount)}}</span>
          <el-input size="mini" v-else @input="onInput(row,'Amount')" v-model="row.Amount"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="TaxRate" label="税率（%）" v-if="InvoiceType!='收据'">
        <template slot-scope="{row}">
          <span v-if="IsDetail">{{row.TaxRate}}</span>
          <el-input size="mini" v-else @input="onInput(row,'TaxRate')" v-model="row.TaxRate"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="TaxAmount" label="税额" v-if="InvoiceType!='收据'">
        <template slot-scope="{row}">
          <span>{{$commonJs.toThousands(row.TaxAmount)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="IncTaxAmount" label="含税金额" v-if="InvoiceType!='收据'">
      <template slot-scope="{row}">
          <span>{{$commonJs.toThousands(row.IncTaxAmount)}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="WriteoffAmount" label="累计结款金额" min-width="110px">
        <template slot-scope="{row}">
          <span v-if="IsDetail">{{row.WriteoffAmount}}</span>
          <el-input v-else @input="onInput(row,'WriteoffAmount')" v-model="row.WriteoffAmount"></el-input>
        </template>
      </el-table-column> -->
      <el-table-column prop="Remark" label="备注" width="200px">
        <template slot-scope="{row}">
          <span v-if="IsDetail">{{row.Remark}}</span>
          <el-input size="mini" v-else type="textarea" autosize @input="onInput(row)" v-model="row.Remark"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="95" fixed="right" v-if="!IsDetail">
        <template slot-scope="{row,$index}">
          <el-link style="margin-right:10px" @click="copyRow(row,$index)" :underline="false">复制</el-link>
          <el-link @click="delRow(row,$index)" :underline="false">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import costSelect from "@/components/basedoc/cost/select";

export default {
  components: { costSelect },
  props: {
    IsDetail: {
      type: Boolean,
      default: false,
    },
    InvoiceType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      cost_api: require("@/api/sale/cost").default,
      Data: [
        {
        DocDtsId: 0,
        DocId: 0,
        CostId: 0, //费用
        CostCode: "",
        CostName: "",
        Amount: null, //金额
        TaxRate: this.DefTaxRate, //税率
        TaxAmount: null, //税额
        IncTaxAmount: null, //含税金额
        // NoTaxAmount: null, //无税金额
        // WriteoffAmount: null, //累计结款金额
        Remark: "",
        T: 0,
      }
      ],
      DelData: [],
      DCost: [],
      DefTaxRate: 0,
      isMB: this.$store.state.isMB, 
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      listTotal:0,
      initDAccount:[],
    };
  },
  methods: {
    resetFun(row){

    //if(!row.CostName){
      this.pageParams.pageIndex=1
      this.DCost=this.initDAccount
      this.listTotal=this.initTotal
    //}


    },
    currentPage(val, row){
      let CostName = row.CostName;
      this.pageParams.pageIndex=val
          this.cost_api.list({ Status: 1,pageIndex: val,pageSize:7, CostName }).then((res) => {
            if (res.Code == 0) {
            this.DCost = res.Data;
            
            this.listTotal=res.Count
            }
          });
    },
    inputText(text, row){
    if (text == row.CostName) {
      //console.log("相同", text);
      return;
    }
    row.CostName = text;
    this.cost_api.list({ Status: 1,pageIndex:1,pageSize:7 ,CostName:text}).then((res) => {
      if (res.Code == 0){this.DCost = res.Data;
            this.listTotal=res.Count} 
    });
    },
    getSummaries(param) {
      
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 3 || index === 5|| index === 6) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return  Number(Number(Number(prev) + value).toFixed(2));
              } else {
                return Number(Number(prev).toFixed(2)) ;
              }
            }, 0);
            if(index!=3){
               sums[index] = this.$commonJs.toThousands(sums[index]);
            }else{
               sums[index] = sums[index]
            }
          }
          return;
        }
      });
      return sums;
    },
    setCost(data, DefTaxRate,type) {
      this.DCost = data.Data;
      this.DefTaxRate = DefTaxRate;
      this.initDAccount=data.Data;
      this.initTotal=data.length
      if(DefTaxRate!=null && type){
      this.Data.forEach(e=>{
        e.TaxRate=this.DefTaxRate
         this.onInput(e,'TaxRate')
      })
      }
    },
    setData(data) {
      this.Data = data;
    },
    getData() {
      var data = this.Data.filter((x) => x.T != null);
      this.DelData.forEach((x) => data.push(x));
      return data;
    },
    rowClick(row) {
       if(!this.IsDetail){
          var index = this.Data.indexOf(row);
          if (index + 1 == this.Data.length) {
            // 
            this.addRow();
          }
       }
    },
    addRow() {
      this.Data.push({
        DocDtsId: 0,
        DocId: 0,
        CostId: 0, //费用
        CostCode: "",
        CostName: "",
        Amount: null, //金额
        TaxRate: this.DefTaxRate, //税率
        TaxAmount: null, //税额
        IncTaxAmount: null, //含税金额
        // NoTaxAmount: null, //无税金额
        // WriteoffAmount: null, //累计结款金额
        Remark: "",
        T: 0,
      });
    },
    onInput(row, type) {
      row.T = row.T == 0 ? 0 : 1;
      if (type) {
        // row[type] = this.$commonJs.obj.toNumber(row[type]);
        if (row.Amount && row.TaxRate) {
          //税额 = 金额 * 税率
          row.TaxAmount = (row.Amount * (row.TaxRate / 100)).toFixed(2);
        } else row.TaxAmount = null;

        if (row.Amount && row.TaxAmount) {
          //含税金额 = 金额 + 税额
          row.IncTaxAmount = (
            parseFloat(row.Amount) + Number(row.TaxAmount)
          ).toFixed(2);
        } else row.IncTaxAmount = row.Amount;
      }
    },
    onSelect(e, row, type) {
      row.T = row.T == 0 ? 0 : 1;
      row.CostId = e.CostId;
      row.CostCode = e.CostCode;
      row.CostName = e.CostName;
      if (e.TaxRate) row.TaxRate = e.TaxRate;
    },
    delRow(row, index) {
      if (row.T != 0) this.DelData.push({ ...row, T: 2 });
      this.Data.splice(index, 1);
    },
    copyRow(row) {
      this.Data.push({ ...row, T: 0 });
    },
    clear() {
      this.Data = [];
      this.DelData = [];
      this.DCost = [];
    },
  },
};
</script>